import { useEffect, useState } from "react";
import React from "react";
import TestComponent from './testComponent'
import { PDFDocument } from "pdf-lib";

const FactsPDF = (props) => {
  const [base64PDF, setBase64PDF] = useState("");

  const injectPDFTitle = async (base64, title) => {

    const safeTitle = (title === null || title === undefined || title === "") ? "document" : title;

    // Strip the "data:application/pdf;base64," prefix if it exists
    const updatedbase64 = base64.replace(/^data:application\/pdf;base64,/, "");

    const binary = Uint8Array.from(atob(updatedbase64), (c) => c.charCodeAt(0));
    const pdfDoc = await PDFDocument.load(binary);

    // Set metadata
    pdfDoc.setTitle(safeTitle);
    // pdfDoc.setAuthor("Your Company");
    // pdfDoc.setSubject("Offer Letter");

    const existingTitle = pdfDoc.getTitle();
    if (existingTitle === safeTitle) {
      // Already injected — return the same base64
      return updatedbase64;
    }

    const updatedBytes = await pdfDoc.save();
    return btoa(String.fromCharCode(...updatedBytes));
  };

  

  useEffect(() => {
    if (props?.data) {
      injectPDFTitle(props.data, props?.pdftitle).then(setBase64PDF);
    }
  }, [props?.data, props?.pdftitle]);

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <iframe
        src={`data:application/pdf;base64,${base64PDF}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "none", // Optional, to remove the iframe border
        }}
        title={props?.pdftitle}
      />
    </div>
  );
};

export default FactsPDF;
